import "./OceanWallet.module.css";
import Header from "@/reusable_sections/Header";
import EliteFitnessPerformance from "./sections/EliteFitnessPerformance";
import StorytellingCapabilities from "./sections/StorytellingCapabilities";
import TheJunkDaddyDifference from "./sections/TheJunkDaddyDifference";
import SeamlessCheckout from "./sections/SeamlessCheckout";
import TransformationGallery from "./sections/TransformationGallery";
import ConsultationCta from "./sections/ConsultationCta";
import VoltFooter from "@/reusable_sections/Footer";
export default function OceanWalletPage() {
  return <div>
      <Header />
      <EliteFitnessPerformance />
      <StorytellingCapabilities />
      <TheJunkDaddyDifference />
      <SeamlessCheckout />
      <TransformationGallery />
      <ConsultationCta />
      <VoltFooter />
    </div>;
}